import _ from 'lodash'
import moment from 'moment'
import Vue from 'vue'
import AntDesign, { message } from 'ant-design-vue'
import App from '@/components/app/App.vue'
import './styles/ant-design.less'
import './styles/main.scss'
import { router } from '@/router/router'
import { api } from '@/api'

declare module 'vue/types/vue' {
  interface Vue {
    $api: typeof api
    $message: typeof message
    $moment: typeof moment
  }
}

Vue.config.productionTip = false
Vue.use(AntDesign)

Vue.prototype.$api = api
Vue.prototype.$dotGet = _.get
Vue.prototype.$moment = moment

new Vue({
  el: '#app',
  render: h => h(App),
  router
})
